import { render, staticRenderFns } from "./SosialSecurity.vue?vue&type=template&id=874c2b2e&"
import script from "./SosialSecurity.vue?vue&type=script&lang=js&"
export * from "./SosialSecurity.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports